class NumFilter extends HTMLElement {
  static get observedAttributes() {
    return ['open-filters'];
  }

  constructor() {
    super();
    this._openFilters = false;
  }

  connectedCallback() {
    this._buttonFilters = this.querySelector('#FiltersButton');
    this._drawerFilters = this.querySelector('#FiltersDrawer');
    this._attachEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open-filters') {
      this._openFilters = newValue === 'true';
      this._toggleDrawer(this._drawerFilters, this._buttonFilters, this._openFilters);
    }
  }

  _toggleDrawer(drawer, trigger, isOpen) {
    console.log(drawer, trigger, isOpen);
    if (!drawer || !trigger) return;
    isOpen ? drawer.open(trigger) : drawer.close();
    trigger.setAttribute('data-open', isOpen);
  }

  toggleFilters() {
    this.setAttribute('open-filters', String(!this._openFilters));
  }

  closeFilters() {
    this.setAttribute('open-filters', 'false');
  }

  _attachEventListeners() {
    if (this._buttonFilters) {
      this._buttonFilters.addEventListener('click', () => this.toggleFilters());
    }

    if (this._drawerFilters) {
      this._drawerFilters.addEventListener('onClose', () => this.closeFilters());
    }
  }
}

customElements.define('num-filter', NumFilter);
